import { z } from "zod";
import { requiredString } from "./primitives";

export const requestMagicLinkSchema = z.object({
  email: requiredString("Email"),
});

export const verifyMagicLinkSchema = z.object({
  token: requiredString("Magic link token"),
});

export type RequestMagicLinkPayload = z.infer<typeof requestMagicLinkSchema>;
export type VerifyMagicLinkPayload = z.infer<typeof verifyMagicLinkSchema>;

export const magicMfaEmptyRequestSchema = z.object({}).strict();
export const magicMfaCodeSchema = z.object({ code: z.string().regex(/^\d{6}$/, "Enter the six-digit authenticator code.") }).strict();
export const magicMfaStatusSchema = z.object({ enabled: z.boolean() }).strict();
export const magicMfaSetupSchema = z.object({ secret: z.string().min(16), uri: z.string().startsWith("otpauth://totp/"), expiresAt: z.string().datetime() }).strict();
export const magicMfaChallengeSchema = z.object({ type: z.literal("magic_totp"), session: z.string().min(32).max(200), expiresAt: z.string().datetime() }).strict();
export const magicMfaVerifySchema = z.object({ session: z.string().min(32).max(200), code: z.string().regex(/^\d{6}$/, "Enter the six-digit authenticator code.") }).strict();
export const magicLinkSignedInSchema = z.object({
  accessToken: z.string().min(1),
  user: z.object({ id: z.string().uuid(), email: z.string().email(), emailVerified: z.literal(true), name: z.string().optional() }).strict(),
}).strict();
export const magicLinkVerificationResponseSchema = z.union([
  magicLinkSignedInSchema,
  z.object({ challenge: magicMfaChallengeSchema }).strict(),
]);
export type MagicMfaChallenge = z.infer<typeof magicMfaChallengeSchema>;
export type MagicLinkVerificationResponse = z.infer<typeof magicLinkVerificationResponseSchema>;
